const sizes = {
  s: '48rem',
  m: '60rem',
  l: '70rem',
  x: '90rem',
}
const breakpoints = Object.values(sizes)

const theme = {
  /***
   * Sizes
   */
  breakpoints,
  sizes,

  /***
   * Colors
   */
  colors: {
    white: '#fff',
    black: '#000',
    gray: {
      30: '#4d4d51',
      60: '#a7a7a9',
      80: '#ddd',
      90: '#f2f2f2',
      95: '#f6f6f6',
    },
    orange: {
      50: '#ff391f',
      60: '#ff7c50',
    },
    green: {
      30: '#337f59',
    },
    yellow: {
      50: '#ddcf51',
      80: '#ffeec4',
    },
    purple: {
      50: '#5163ba',
      70: '#908fd6',
    },
    teal: {
      40: '#4db3c4',
    },
    blue: {
      60: '#809fbb',
    },
  },

  /***
   * Fonts
   */
  fonts: {
    sans: 'Inter, system-ui',
  },
  fontSizes: {
    t: '0.625rem',
    s: '0.75rem',
    b: '0.875rem',
    m: '1rem',
    l: '1.25rem',
    x: '1.75rem',
  },
  fontSizeScales: {},
  fontWeights: {
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800,
    black: 900,
  },
  lineHeights: {
    solid: 1,
    title: 1.1,
    copyTight: 1.25,
    copy: 1.5,
  },

  /***
   * Spacing
   */
  spaceScales: {},

  /***
   * Transitions
   */
  transitionDurations: {
    slow: '300ms',
    normal: '200ms',
    fast: '100ms',
  },

  /***
   * Variants
   */
  textStyles: {
    caps: {
      textTransform: 'uppercase',
    },
    trackedCaps: {
      textTransform: 'uppercase',
      letterSpacing: '0.075em',
    },
    lowercase: {
      textTransform: 'lowercase',
    },
    capitalize: {
      textTransform: 'capitalize',
    },
  },
  boxStyles: {
    lastNoMargin: {
      '&:last-child': {
        marginBottom: 0,
        marginRight: 0,
      },
    },
    firstLastNoMargin: {
      '&:first-child': {
        marginTop: 0,
        marginLeft: 0,
      },
      '&:last-child': {
        marginBottom: 0,
        marginRight: 0,
      },
    },
  },

  /***
   * Media queries
   */
  mediaQueries: Object.keys(sizes).reduce((acc, key) => {
    acc[key] = `@media screen and (min-width: ${sizes[key]})`

    return acc
  }, {}),
}

exports.theme = theme
